/**
 * Le bouton de création flottant, sur téléphone.
 *
 * Sur un téléphone, créer coûtait trois gestes : ouvrir le menu, aller sur la
 * liste, appuyer sur « Nouveau ». Ce bouton ouvre la palette d'un pouce, là où
 * le pouce tombe.
 *
 * Il se retire sur les écrans de saisie — un devis en cours d'édition porte
 * déjà sa barre d'enregistrement en bas, et un bouton posé dessus ferait
 * appuyer sur la mauvaise chose au pire moment.
 */
import { Plus } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useUiStore } from "@/stores/uiStore";

/** Les écrans où l'on est déjà en train de créer ou de modifier. */
const EN_SAISIE = /\/(new|edit|modifier)$/;

export function CreateFab() {
  const { pathname } = useLocation();
  const open = useUiStore((s) => s.paletteOpen);
  const setOpen = useUiStore((s) => s.setPaletteOpen);

  if (open || EN_SAISIE.test(pathname)) return null;

  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      aria-label="Créer"
      className="fab-creer lg:hidden fixed right-4 bottom-[calc(1rem+env(safe-area-inset-bottom))] z-40 w-14 h-14 flex items-center justify-center bg-accent hover:bg-accent-hover text-accent-contrast shadow-lg transition-transform duration-100 ease-out active:scale-95"
    >
      <Plus size={26} />
    </button>
  );
}
